import { useId } from 'react';

const useDialogLabels = ({ title, subtitle, descriptionId }) => {
    const id = useId();
    const titleId = title ? `${id}-title` : undefined;
    const subtitleId = subtitle ? `${id}-subtitle` : undefined;

    return {
        headerProps: { titleId, subtitleId },
        dialogProps: {
            role: 'dialog',
            'aria-labelledby': titleId,
            'aria-describedby': descriptionId || subtitleId,
        },
    };
};

export default useDialogLabels;
